/**
 * Copyright (C) 2019 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'
import scopedCss from 'lui-productlogo.scss'
import template from 'lui-productlogo.html'

export default class LuiProductlogo extends LuiBase {
  static get is() {
    return 'lui-productlogo'
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }

  init() {
    super.init()
    const a = this.closest('a')
    if (a) {
      a.classList.add('lui-reset-styles')
      a.classList.add('lui-interactive')
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-logo/lui-productlogo.js
// module id = 237
// module chunks = 0 1 10